import api from './api';

// Thin wrapper around RTCPeerConnection for a single 1:1 audio call.
// The signaling itself (offer/answer/ICE relay) happens over the
// existing chat Socket.IO connection -- see CallContext.

export async function createPeerConnection() {
  let iceServers = [{ urls: 'stun:stun.l.google.com:19302' }];
  try {
    const creds = await api.getTurnCredentials();
    if (creds.iceServers) iceServers = creds.iceServers;
  } catch {
    // Fall back to public STUN only -- calls between two peers on an
    // open network will still connect, just not through NAT/firewalls
    // that need a relay.
  }
  return new RTCPeerConnection({ iceServers });
}

export async function getMicrophoneStream() {
  return navigator.mediaDevices.getUserMedia({ audio: true, video: false });
}

export function stopStream(stream) {
  stream?.getTracks().forEach((track) => track.stop());
}
